import React from 'react';
import IcQuestion from 'assets/images/backoffice/capital/ic-question-mark.svg';
import Button from '../Button';
import styles from './InfoCard.css';
import InfoCard from './InfoCard';
import ListItem from '../ListItem';

function FastLoanProcess() {
  return (
    <InfoCard
      title="Proses Pengajuan Fast Loan"
      icon={<img src={IcQuestion} className={styles.question} />}
    >
      <div className={styles['fast-loan-process']}>
        <ListItem number={1}>Pengisian form aplikasi oleh pengguna</ListItem>
        <ListItem number={2}>Data masuk ke database Moka POS</ListItem>
        <ListItem number={3}>
          Data dikirim sementara ke database Commonwealth Bank
        </ListItem>
        <ListItem number={4}>Pengguna mendapatkan email notifikasi</ListItem>
        <ListItem number={5}>
          Pengguna melakukan penyelesaian proses pinjaman di eKiosk Commonwealth
          Bank
        </ListItem>
        <ListItem number={6} last>
          Pencairan dana dilakukan melalui rekening Commonwealth Bank
        </ListItem>
        <div className={styles['fast-loan-action']}>
          <Button
            title="Baca FAQ"
            btnType="outline"
            href="http://info.mokapos.com/faq-commonwealth"
            target="_blank"
            rel="noopener noreferrer"
          />
        </div>
      </div>
    </InfoCard>
  );
}

export default FastLoanProcess;
